import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { ITipsResults } from '../models/tipsResults';

@Injectable({
  providedIn: 'root'
})
export class TipService {
  constructor(
    private http: HttpClient,
    private errorService: ErrorService
  ) { }

  getTipsByBuildingId(buildingId: string): Observable<ITipsResults> {
    const url = environment.tipsApiBaseUrl + endpoints.getTipsForBuilding.replace(':buildingId', buildingId);
    return this.http.get<ITipsResults>(url).pipe(
      catchError(this.errorService.handleError)
    );
  }

  saveTipsAssessRel(buildingId: number, tipId: number, caseId: string): Observable<any> {
    const url = environment.apiBaseUrl + endpoints.updateTipsAssessRel;
    return this.http.post(url, { building_id: buildingId, tip_id: tipId, case_id: caseId });
  }
}
